export default __webpack_public_path__ + "static/media/file_type_pdf.13388e70.svg";